export default __webpack_public_path__ + "static/media/github-icon.93a3b32b.svg";